import { useTranslation } from 'react-i18next';

import { taskService } from 'bom/services';
import { FormField, IAutocompleteProps } from 'core/components';
import { InputType } from 'core/enums';
import { useFormContext } from 'core/states';

interface IProps extends IAutocompleteProps {
  name: string;
  label?: string;
}

export const TaskFormField = ({ name = 'task', label, ...rest }: IProps) => {
  const { t } = useTranslation();

  const { control, errors } = useFormContext();

  return (
    <FormField
      name={name}
      type={InputType.AUTOCOMPLETE}
      inputProps={{
        label: label || t('labelTask'),
        placeholder: t('placeholderSelectTask'),
        control,
        error: errors[name],
        getOptions: taskService.getTasksAutocomplete,
        enabledOnFocus: false,
        ...rest,
      }}
    />
  );
};
